module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/gacha_4-47d9c395a4b4fe1acacd613300518bfc.png";